export default {"src":"/_next/static/media/collaborator-disabled.814332f4.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};